<form class="user-info-edit" [formGroup]="form">
  <div class="user-info-edit__block">
    <app-photo
      class="image"
      [mode]="formDisabled ? 'view' : 'edit'"
      [type]="'photo'"
      [id]="data?.photoId"
      [height]="isLargeScreen ? '144px' : '96px'"
      [width]="isLargeScreen ? '144px' : '96px'"
      [borderRadius]="isLargeScreen ? '144px' : '96px'"
      [rounded]="true"
      [loading]="loading"
      (photoChange)="onPhotoChange($event)"
      (photoDeleted)="onPhotoDeleted()"
    ></app-photo>

    <tui-input
      tuiAutoFocus
      tabindex="2"
      [tuiSkeleton]="loading"
      formControlName="lastName"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.userInfo.fields.lastName' | translate }}
      <span class="tui-required"></span>
      <input tuiTextfieldLegacy [attr.autocomplete]="autocompleteTypes.lastName" />
    </tui-input>

    <tui-input
      tabindex="3"
      formControlName="firstName"
      [tuiSkeleton]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.userInfo.fields.firstName' | translate }}
      <span class="tui-required"></span>
      <input tuiTextfieldLegacy [attr.autocomplete]="autocompleteTypes.firstName" />
    </tui-input>

    <tui-input
      tabindex="4"
      formControlName="middleName"
      [tuiSkeleton]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.userInfo.fields.middleName' | translate }}
      <input tuiTextfieldLegacy [attr.autocomplete]="autocompleteTypes.middleName" />
    </tui-input>

    <div class="field">
      <div tuiGroup>
        <tui-input-number
          tabindex="5"
          formControlName="birthDateDay"
          [tuiSkeleton]="loading"
          [tuiTextfieldSize]="tuiElementLargeSize"
          [tuiTextfieldCleaner]="true"
          [min]="1"
          [max]="31"
        >
          {{ 'components.userInfo.fields.day' | translate }}
        </tui-input-number>

        <tui-select
          tabindex="6"
          formControlName="birthDateMonth"
          [tuiSkeleton]="loading"
          [tuiTextfieldSize]="tuiElementLargeSize"
          [tuiTextfieldCleaner]="true"
          [valueContent]="months ? monthStringify(months) : ''"
        >
          {{ 'components.userInfo.fields.month' | translate }}
          <tui-data-list *tuiDataList>
            <button *ngFor="let month of months" tuiOption [value]="month.id">
              {{ month.name | translate }}
            </button>
          </tui-data-list>
        </tui-select>

        <tui-input-year
          tabindex="7"
          formControlName="birthDateYear"
          [tuiSkeleton]="loading"
          [tuiTextfieldSize]="tuiElementLargeSize"
          [tuiTextfieldCleaner]="true"
          [min]="1900"
          [max]="2990"
        >
          {{ 'components.userInfo.fields.year' | translate }}
        </tui-input-year>
      </div>
    </div>

    <ng-container *ngIf="!(allowOnlyYourShortProfileEditing$ | async)">
      <!-- FIXME: app-input-phone -->
      <app-input-phone
        *ngIf="mode === 'create' && (allowSpecialFieldsEditing$ | async)"
        #phone
        tabindex="8"
        formControlName="phone"
        [tuiSkeleton]="loading"
        [size]="tuiElementLargeSize"
        [pseudoInvalid]="phone.invalid || (phone.touched && form.errors?.['atLeastOne'])"
        [forceDisabled]="mode === 'create' ? phoneControl.disabled : undefined"
      >
        {{ 'components.userInfo.fields.mobilePhone' | translate }}
      </app-input-phone>
    </ng-container>

    <tui-input
      *ngIf="mode === 'create' || (allowEmailFieldEditing$ | async)"
      #email
      tabindex="9"
      formControlName="email"
      [tuiSkeleton]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [pseudoInvalid]="email.touched && form.errors?.['atLeastOne']"
    >
      {{ 'components.userInfo.fields.email' | translate }}
      <input tuiTextfieldLegacy [attr.autocomplete]="autocompleteTypes.email" />
    </tui-input>

    <ng-container *ngIf="!(allowOnlyYourShortProfileEditing$ | async)">
      <tui-textarea
        class="field field_height_min"
        tabindex="11"
        formControlName="resources"
        [tuiSkeleton]="loading"
        [tuiTextfieldSize]="tuiElementLargeSize"
        [expandable]="true"
      >
        {{ 'components.userInfo.fields.resources' | translate }}
      </tui-textarea>

      <tui-input
        tabindex="12"
        formControlName="hobbies"
        [tuiSkeleton]="loading"
        [tuiTextfieldSize]="tuiElementLargeSize"
      >
        {{ 'components.userInfo.fields.hobbies' | translate }}
      </tui-input>

      <ng-container *ngIf="allowSpecialFieldsForAssociationEditing$ | async">
        <search-users-input
          *ngIf="authUser$ | async as authUser"
          mode="single"
          formControlName="curator"
          [label]="'components.userInfo.fields.curator' | translate"
          [tuiSkeleton]="loading"
          [filter]="{
            searchForRegistredOnly: true,
            organisationIds: authUser.parentOrganisationId ? [authUser.parentOrganisationId] : [],
          }"
          [excludeFilterFields]="['organizations']"
          [showFilterButton]="true"
          [textfieldSize]="tuiElementLargeSize"
        ></search-users-input>

        <tui-input-date
          tabindex="13"
          formControlName="authorityValidTill"
          [tuiSkeleton]="loading"
          [tuiTextfieldSize]="tuiElementLargeSize"
        >
          {{ 'components.userInfo.fields.authorityValidTill' | translate }}
        </tui-input-date>

        <ng-container *ngIf="!form.value.oldPaymentDetails">
          <app-input-files
            class="field size_{{ tuiElementLargeSize }}"
            tabindex="14"
            formControlName="paymentDetails"
            accept=".pdf, .doc, .docx, .rtf"
            [label]="' '"
            [link]="'label.userProfileAttachment' | customNames"
            [size]="tuiElementLargeSize"
            [maxFileSize]="maxDocFileSize"
            [loading]="loading"
          ></app-input-files>
        </ng-container>
        <ng-container *ngIf="!!form.value.oldPaymentDetails">
          <app-input-files
            class="field size_{{ tuiElementLargeSize }}"
            tabindex="14"
            formControlName="oldPaymentDetails"
            accept=".pdf, .doc, .docx, .rtf"
            [label]="' '"
            [link]="'label.userProfileAttachment' | customNames"
            [size]="tuiElementLargeSize"
            [maxFileSize]="maxDocFileSize"
            [loading]="loading"
          ></app-input-files>
        </ng-container>

        <div [tuiSkeleton]="loading">
          <app-field-wrapper [text]="'components.userInfo.fields.feeNotPaid' | translate" [size]="tuiElementMediumSize">
            <app-toggle tabindex="16" [size]="'m'" formControlName="isFeePaid"></app-toggle>
          </app-field-wrapper>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="allowLoyaltyFieldsEditing$ | async">
      <app-search-cities-input
        formControlName="city"
        mode="single"
        [loading]="loading"
        [textfieldSize]="tuiElementLargeSize"
        [textfieldLabelOutside]="false"
      >
        {{ 'components.userInfo.fields.city' | translate }}
      </app-search-cities-input>

      <lp-categories-field
        formControlName="favoriteCategories"
        [externalLoading]="loading"
        [textfieldSize]="tuiElementLargeSize"
        [mode]="'edit'"
      >
        {{ 'components.userInfo.fields.favoriteCategories' | translate }}
      </lp-categories-field>
    </ng-container>
  </div>

  <ng-container *ngIf="!(allowOnlyYourShortProfileEditing$ | async)">
    <div class="user-info-edit__organisations" formArrayName="organisations">
      <tui-island *ngFor="let organisation of organisations.controls; let oIndex = index" class="tui-island">
        <button
          *ngIf="allowIsDefaultOrganisationEditing$ | async"
          tuiIconButton
          type="button"
          appearance="icon"
          size="xs"
          [disabled]="isDefaultOrganisation(oIndex)"
          (click)="isDefaultOrganisation(oIndex) ? undefined : setDefaultOrganisation(oIndex)"
        >
          <tui-icon
            class="tui-island__icon"
            [class.tui-island__icon_isDefault]="isDefaultOrganisation(oIndex)"
            [icon]="'@tui.star'"
            [background]="'@tui.star-filled'"
          ></tui-icon>
        </button>

        <span class="tui-island__title">{{ organisation.get('organisationName')?.value }}</span>
        <div class="tui-island__paragraph item" [formGroupName]="oIndex">
          <ng-container *ngIf="getAllowJobTitlesFieldsEditing(organisation.get('organisationId')?.value)">
            <tui-input
              class="field"
              tabindex="17"
              formControlName="jobTitlesDescription"
              [tuiSkeleton]="loading"
              [tuiTextfieldSize]="tuiElementLargeSize"
            >
              {{ 'components.userInfo.fields.jobTitlesDescription' | translate }}
            </tui-input>

            <app-job-title-field
              class="field"
              tabindex="18"
              formControlName="jobTitlesIds"
              [jobTitles]="jobsForEditing$ | async"
              [size]="tuiElementLargeSize"
              [loading]="loading"
            ></app-job-title-field>
          </ng-container>

          <div *ngIf="(allowSpecialFieldsEditing$ | async) && (allowAssociationEmployeeEditing$ | async)">
            <tui-select
              *tuiLet="
                (organisation.get('organisationId')?.value === currentParentOrganisationId || isParentOrganisation
                  ? rolesForAssociation$
                  : rolesForOrganisation$
                ) | async as roles
              "
              class="field"
              tabindex="19"
              formControlName="roleIds"
              [tuiSkeleton]="loading || !roles?.length"
              [class.tui-skeleton_text]="loading || !roles?.length"
              [valueContent]="roles ? rolesStringify(roles) : ''"
              [tuiTextfieldSize]="tuiElementLargeSize"
            >
              {{ 'components.userInfo.fields.role' | translate }}
              <span class="tui-required"></span>
              <tui-data-list *tuiDataList>
                <button *ngFor="let role of roles" tuiOption [value]="[role.id]">
                  {{ role.description }}
                </button>
              </tui-data-list>
            </tui-select>
          </div>
        </div>
      </tui-island>
    </div>

    <app-contacts
      class="user-info-edit__contacts"
      formControlName="contacts"
      [allowCreating]="allowContactFieldCreating$ | async"
      [allowEditing]="allowContactFieldEditing$ | async"
      [allowDeleting]="allowContactFieldDeleting$ | async"
      [loading]="loading"
    ></app-contacts>
  </ng-container>

  <div *ngIf="(authUser$ | async)?.id === data?.id" class="user-info-edit__delete-link" [tuiSkeleton]="loading">
    <app-delete-auth-user-link [(processing)]="loading"></app-delete-auth-user-link>
  </div>

  <div *ngIf="!loading" class="user-info-edit__buttons">
    <button
      tuiButton
      class="user-info-edit-button"
      tabindex="26"
      type="button"
      appearance="primary"
      [size]="tuiElementLargeSize"
      (click)="onClickSaveButton()"
    >
      {{ 'common.buttons.save' | translate }}
    </button>

    <button
      tuiButton
      class="user-info-edit-button"
      tabindex="27"
      type="button"
      appearance="secondary"
      [size]="tuiElementLargeSize"
      (click)="onClickCancelButton()"
    >
      {{ 'common.buttons.cancel' | translate }}
    </button>
  </div>
</form>
